export default function Go_Study_Plan() {
  return (
    <div>
      <h1>Go_Study_Plan </h1>
      <p>Go Study Plan</p>
    </div>
  );
}
